<template>
  <div class="plans">
    <div class="plan-grid">
      <article
        v-for="(p, i) in plans"
        :key="p.key"
        class="plan card card-pad reveal"
        v-reveal="{ delay: i * 90 }"
      >
        <header class="plan-head">
          <span class="plan-step">档位 0{{ i + 1 }}</span>
          <h3 class="plan-name">{{ p.name }}</h3>
          <p class="plan-fit">{{ p.fit }}</p>
          <span class="plan-cycle"><IconSvg name="clock"/> 典型周期 {{ p.cycle }}</span>
        </header>

        <ul class="plan-items">
          <li v-for="(it, ii) in p.items" :key="ii">
            <IconSvg name="check"/>
            <span>{{ it }}</span>
          </li>
        </ul>

        <router-link to="/contact" class="btn btn-link plan-cta">
          咨询这一档
          <IconSvg name="arrow-right"/>
        </router-link>
      </article>
    </div>

    <div class="pricing card card-pad reveal" v-reveal="{ delay: 120 }">
      <div class="pricing-main">
        <h3 class="pricing-title"><IconSvg name="file"/> 报价与投入</h3>
        <p class="pricing-basis">{{ pricing.basis }}</p>
      </div>
      <ul class="pricing-notes">
        <li v-for="(n, i) in pricing.notes" :key="i">
          <IconSvg name="check"/>
          <span>{{ n }}</span>
        </li>
      </ul>
      <p class="pricing-hint">
        需要具体报价？把现场情况告诉我们，工作日 1 天内响应，先判断可行性再谈价格。
      </p>
    </div>
  </div>
</template>

<script>
import IconSvg from '@/components/common/IconSvg'

/**
 * 选型三档 + 报价口径
 * 数据来源：site.js 各业务线的 plans / pricing
 * 设计要点：档位帮客户自我定位（低决策门槛），报价口径统一说明（减少无效询价与返工）
 */
export default {
  name: 'PlanTiers',
  components: { IconSvg },
  props: {
    plans: { type: Array, required: true },
    pricing: { type: Object, required: true }
  }
}
</script>

<style lang="scss" scoped>
.plan-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.plan {
  --ico: 16px;
  display: flex;
  flex-direction: column;
  gap: 18px;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    inset: 0 0 auto 0;
    height: 3px;
    background: linear-gradient(90deg, var(--accent), var(--accent2));
    opacity: 0.85;
  }
}

.plan-head {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.plan-step {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.2em;
  color: var(--accent-txt);
}

.plan-name {
  font-size: 21px;
  font-weight: 700;
  color: #fff;
  margin: 0;
}

.plan-fit {
  margin: 0;
  font-size: 14.5px;
  color: var(--txt-2);
}

.plan-cycle {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  align-self: flex-start;
  margin-top: 2px;
  padding: 7px 13px;
  border: 1px solid var(--line);
  border-radius: 999px;
  font-size: 13px;
  color: var(--txt-2);

  svg {
    color: var(--accent-txt);
  }
}

.plan-items {
  --ico: 15px;
  display: flex;
  flex-direction: column;
  gap: 11px;
  margin: 0;
  padding: 0;
  list-style: none;
  flex: 1;

  li {
    display: flex;
    align-items: flex-start;
    gap: 9px;
    font-size: 14.5px;
    line-height: 1.6;
    color: var(--txt-2);
  }

  svg {
    margin-top: 4px;
    color: var(--accent-txt);
    flex-shrink: 0;
  }
}

.plan-cta {
  --ico: 16px;
  align-self: flex-start;
  /* 文字按钮在卡片里也保证触控高度（≥42px），避免小屏点不准 */
  min-height: 42px;
  padding-left: 0;
  align-items: center;
}

.pricing {
  --ico: 16px;
  margin-top: 22px;
  display: grid;
  grid-template-columns: 1.05fr 1.4fr;
  gap: 22px 34px;
  align-items: start;

  .pricing-title {
    display: flex;
    align-items: center;
    gap: 9px;
    margin: 0 0 8px;
    font-size: 18px;
    color: #fff;

    svg {
      color: var(--accent-txt);
    }
  }

  .pricing-basis {
    margin: 0;
    font-size: 14.5px;
    line-height: 1.7;
    color: var(--txt-2);
  }

  .pricing-notes {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin: 0;
    padding: 0;
    list-style: none;

    li {
      display: flex;
      align-items: flex-start;
      gap: 9px;
      font-size: 14px;
      line-height: 1.65;
      color: var(--txt-2);
    }

    svg {
      margin-top: 4px;
      color: var(--accent-txt);
      flex-shrink: 0;
    }
  }

  .pricing-hint {
    grid-column: 1 / -1;
    margin: 0;
    padding-top: 16px;
    border-top: 1px solid var(--line);
    font-size: 14px;
    color: var(--txt-3);
  }
}

@media (max-width: 980px) {
  .plan-grid {
    grid-template-columns: 1fr;
  }

  .pricing {
    grid-template-columns: 1fr;
    gap: 18px;
  }
}
</style>
